export default __webpack_public_path__ + "static/media/a012-market-line-1.63c8c659.svg";